"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _excluded = ["align", "tag", "children", "color", "size", "weight"];

var Text = function Text(_ref) {
  var align = _ref.align,
      tag = _ref.tag,
      children = _ref.children,
      color = _ref.color,
      size = _ref.size,
      weight = _ref.weight,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_styles.Body, Object.assign({
    as: tag,
    align: align,
    color: color,
    size: size,
    weight: weight
  }, rest), children);
};

Text.defaultProps = {
  align: 'left',
  tag: 'p',
  size: 'body01',
  color: 'textDefault'
};
var _default = Text;
exports.default = _default;